exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-social {\n  font-size: 1.4em;\n  cursor: pointer;\n}\n.icon-social span {\n  padding: 10px;\n}\n.popper {\n  min-width: 150px;\n}\n.mobileshare i {\n  color: black !important;\n}\n.mobileshare .icon-social {\n  display: flex;\n}", ""]);

// exports
